<template>
  <div>
    <img style="margin-top: 5px; margin-right: 10px" :src="'/img/py_logo/'+order.store.logo"
         :title="order.store.store_name" height="40px"
    >
    <b-badge variant="primary" size="xs" class="badge-glow">{{ order.store.store_name }}</b-badge>
    <br>
    <div v-if="order.tracking && order.tracking.company && [1,2,4].includes(order.store_id)">
      <img
          style="margin-top: 5px"
          :src="'/img/kargo_logo/'+order.tracking.company.image_url"
          :title="order.tracking.company.name"
          width="100px"
          @dblclick="changeOrderCargo"
      >
    </div>
    <div v-else>
      <b-form-group label="Kargo Firması">
        <v-select
            label="Name"
            :options="_providers"
            :reduce="status => status.ShortName"
            class="select-size-sm"
            @option:selected="selectedOption"
        />
      </b-form-group>
    </div>
    <br>
    <b v-if="order.tracking">
      <feather-icon icon="CopyIcon" @click="doCopy(order.tracking.tracking_number)"/>
      {{ order.tracking.tracking_number }}
    </b>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import vSelect from 'vue-select'

export default {
  name: "OrderListCargo.vue",
  props: {
    order: {
      type: Object,
      required: true,
    }
  },
  components: {vSelect},
  computed: {
    ...mapGetters('orderCargo', ['_providers'])
  },
  methods: {
    changeOrderCargo() {
      this.$store.dispatch('orderCargo/getProviders', this.order.id)
    },
    selectedOption(provider) {
      this.$store.dispatch('orderCargo/setProvider', [this.order.id, provider.ShortName])
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
